import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Edit = loadable(() => import('./Edit'), {});
export const Simulate = loadable(() => import('./Simulate'), {});
